<template>
  <section class="login-container">
    <!-- Login Form -->
    <div class="form">
      <RouterView :invite-token="inviteToken" />
    </div>
  </section>
</template>

<script setup lang="ts">
  import router from '@/router'
  import { useSessionStore } from '@/stores/sessionStore'

  const sessionStore = useSessionStore()

  // If set get invite token from url
  const inviteToken = router.currentRoute.value.query.inviteToken as
    | string
    | undefined

  onMounted(() => {
    watch(
      () => [sessionStore.status, inviteToken],
      () => {
        // Do not set autoLogin, if route has been explicitly set to /company (e.g. router push to /login/company to switch companies)
        if (router.currentRoute.value.path == '/login/company') return

        // If invite token is set and user is logged in
        if (inviteToken && sessionStore.status === 'LOGGED_IN') {
          router.push({
            path: '/login/invite',
            query: { inviteToken: inviteToken },
          })
          return
        }

        if (inviteToken) {
          router.push({
            path: '/login',
            query: { inviteToken: inviteToken, mode: 'register' },
          })
        }

        if (
          sessionStore.status === 'LOGGED_IN' &&
          router.currentRoute.value.query.mode !== 'verify-email'
        ) {
          router.push({
            path: '/login/company',
            query: { autoLogin: 'true' },
          })
        }
      },
      { immediate: true }
    )
  })
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }

  .login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background: var(--sm-background);
  }

  .form {
    border-radius: var(--border-radius);
    background-color: var(--sm-elevation);
    max-width: 430px;
    width: 100%;
    padding: 30px;
    box-shadow: var(--shadow-wide);
  }

  // Language selector
  .header-menu {
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
  }

  .flag-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    overflow: hidden;
    cursor: pointer;
  }
</style>
